"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateOffthreadVideoImageFormat = void 0;

var validateOffthreadVideoImageFormat = function validateOffthreadVideoImageFormat(input) {
  if (typeof input === 'undefined') {
    return;
  }

  if (typeof input !== 'string') {
    throw new TypeError("<OffthreadVideo imageFormat=\"\"> must be a string, but got ".concat(JSON.stringify(input), " instead."));
  }

  if (input !== 'png' && input !== 'jpeg') {
    throw new TypeError("<OffthreadVideo imageFormat=\"\"> must be either \"png\" or \"jpeg\", but got ".concat(input));
  }
};

exports.validateOffthreadVideoImageFormat = validateOffthreadVideoImageFormat;